import { Text, VStack } from '@aj/ui';

import { useAppData } from '../data/AppDataProvider.js';
import { useTodayView, useWeekStrip } from '../data/hooks.js';
import { DESKTOP, useMediaQuery } from '../hooks/useMediaQuery.js';
import { useT } from '../providers/I18nProvider.js';
import { Dashboard } from './home/Dashboard.js';
import { Today } from './home/Today.js';

/**
 * Home — two screens, one job.
 *
 * On a phone it is today's list (§6). On a desktop it is the habit × date wall
 * chart, because that is what the screen is for and what students already copy
 * off Instagram. Both read the same selectors and write the same events; only
 * the layout differs, and this file is the only place that knows which.
 */

export type HomeProps = {
  onNavigate: (tab: string) => void;
};

export function Home({ onNavigate }: HomeProps) {
  const t = useT();
  const view = useTodayView();
  const week = useWeekStrip();
  const { ready, error } = useAppData();
  const desktop = useMediaQuery(DESKTOP);

  // Storage is the whole app — if it won't open there is nothing to show, so
  // say that plainly rather than rendering an empty page.
  if (error) {
    return (
      <VStack gap={2} as="main" className="flex-1 px-5 py-6">
        <Text variant="body" tone="danger">
          {t('error.storage')}
        </Text>
        <Text variant="caption" tone="subtle">
          {error.message}
        </Text>
      </VStack>
    );
  }

  if (!ready) return null;

  return desktop ? (
    <Dashboard view={view} onNavigate={onNavigate} />
  ) : (
    <Today view={view} week={week} onNavigate={onNavigate} />
  );
}
